<template>
    <div @click="showEditModal"><font-awesome-icon icon="pen" fixed-width /> {{$t('buttons.edit')}}</div>
</template>

<script>
  export default {
    name: "FileRenameButton",
    // data(){
    //   return {
    //     showModal: false
    //   }
    // },
    props:['file'],
    methods:{
      showEditModal(){
        this.$root.$children[0].$refs.customPopUp.init({
          title: 'Editing ' + this.file.filename,
          component: 'FileEdit',
          mClass: 'modal--edit',
          data: this.file
        })
      }
    }
  }
</script>

<style scoped>

</style>
